import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbRelatorioPrimeiroAcessoConta } from 'app/abstract/full-pages/relatorios/relatorio-primeiro-acesso-conta.abstract';

@Injectable({ providedIn: 'root' })
export class RelatorioPrimeiroAcessoContaServices extends AbRelatorioPrimeiroAcessoConta {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllAcessos(filter: AppFilter): Observable<any> {
    return this.getAll(`relatorio_primeiro_acesso/conta/`, filter.encode());
  }

  public getGrupos() {
    return this.get(`grupopessoas/allgrupopessoas`);
  }

  public getRelatorio(filter: AppFilter): Observable<any> {
    return this.get(`relatorio_primeiro_acesso/relatorio/${filter.encode()}`);
  }
}